import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';

import FormattedMessage from '~/components/common/FormattedMessage';

import {
  fetchStream,
  followStream,
  getStreamByUsername,
} from '~/modules/streams';

import { useAppDispatch, useAppSelector } from '~/hooks/redux';

import Button, { ButtonProps } from '..';

interface FollowButtonProps extends Omit<ButtonProps, 'children'> {
  small?: boolean;
  username: string;
  className?: string;
}

const FollowButton = ({ small, username, ...props }: FollowButtonProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isSignedIn } = useAppSelector((state) => state.currentUser);
  const stream = useAppSelector((state) =>
    getStreamByUsername(state, username)
  );

  useEffect(() => {
    // @ts-expect-error
    if (!stream) dispatch(fetchStream(username));
  }, [stream, username]);

  const toggleFollow = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isSignedIn) {
        return navigate('/login');
      }

      const isFollowing =
        stream.following !== undefined && stream.following.value;

      // @ts-expect-error
      dispatch(followStream(stream.username, !isFollowing));
    },
    [dispatch, isSignedIn, stream]
  );

  if (!stream) return null;

  const isFollowing = stream.following !== undefined && stream.following.value;
  const label = isFollowing ? (
    <FormattedMessage id="FollowButton_Following" defaultMessage="Following" />
  ) : (
    <FormattedMessage id="FollowButton_Follow" defaultMessage="Follow" />
  );

  return (
    <Button
      size={small ? 'tiny' : undefined}
      color="black"
      onClick={toggleFollow}
      {...props}
    >
      {label}
    </Button>
  );
};

export default FollowButton;
